$(document).ready(function () {
  // Check if the user is on a mobile device
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    // If on a mobile device, remove zoom functionality
    $(".zoom").trigger("zoom.destroy");
  } else {
    // If not on a mobile device, apply zoom functionality
    $(".zoom").zoom();
  }
});
// $(document).ready(function() {

//       $('body').on('click', '.product-form__buttons [name="add"]', function() {
//         if ($('#agree').is(':checked')) {
//           $(this).submit();
//         }
//         else {
//           $('.term_conditions').addClass("tnc-error");
//           return false;
//         }
//       });
// });
